import { TravelInputModeEnum } from './travel-input-mode.enum'

export const getTravelInputClassNameByEnum = (mode: TravelInputModeEnum) => {
  switch (mode) {
    case TravelInputModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
